import React from "react";
import { Button, useNotify } from "react-admin";
import ConfirmModal from "server/components/Modals/ConfirmModal";
import SchoolIcon from "@mui/icons-material/School";
import dataProvider from "server/dataProvider";
import { graduationRequests } from "api/graduationApi";

const StartInternshipDialog = ({
  userId,
  specialityId,
  studyGroup,
  educationId,
  fetchHistory,
  fetchInternshipStudentStatus,
}) => {
  const notify = useNotify();

  const handleSubmit = async () => {
    const payload = { userId, specialityId, studyGroup };
    await dataProvider.customRequest(graduationRequests.startInternshipForStudent(educationId), payload, "POST");

    notify("Успешно добавихте студента в преддипломен стаж");
    fetchHistory();
    fetchInternshipStudentStatus();
  };

  return (
    <ConfirmModal
      onConfirm={handleSubmit}
      titleContent={"Добави студента в преддипломен стаж"}
      triggerButton={
        <Button
          size="medium"
          variant="outlined"
          label="Добави в преддипломен стаж"
          startIcon={<SchoolIcon />}
        />
      }
      message="Сигурни ли сте, че искате да добавите студента в преддипломен стаж ?"
    />
  );
};

export default StartInternshipDialog;
